import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection2Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/smm1b3oakb`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection2Video;
